import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_CALLBACK_URL } from '../config/auth0';
import { startAuth0PKCE } from '../utils/auth0pkce';

/**
 * Hook pour gérer les erreurs d'authentification globales
 */
export function useAuthErrorHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthError = (event: CustomEvent) => {
      const { status, message } = event.detail;
      
      console.warn('🚨 Erreur d\'authentification détectée:', { status, message });
      
      if (status === 401) {
        // Token expiré ou invalide
        console.log('🔑 Token invalide, redirection vers authentification...');
        
        // Nettoyer les tokens invalides
        localStorage.removeItem('auth0_token');
        localStorage.removeItem('auth0_refresh_token');
        
        // Stocker la page actuelle pour redirection après login
        const currentPath = window.location.pathname + window.location.search;
        if (!currentPath.includes('/auth/')) {
          sessionStorage.setItem('auth0_redirect_after_login', currentPath);
        }
        
        // Rediriger vers Auth0
        startAuth0PKCE('login', AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_CALLBACK_URL);
      }
    };

    // Écouter les erreurs d'authentification
    window.addEventListener('auth:error', handleAuthError as EventListener);
    
    return () => {
      window.removeEventListener('auth:error', handleAuthError as EventListener);
    };
  }, [navigate]);
}
